// extracted by mini-css-extract-plugin
module.exports = {"fieldset":"comment_fieldset__2KOmm"};